import {deserializeAs} from 'cerialize';

export class SituationCompteur {
  @deserializeAs('numero_rue')
  numeroRue: string;

  @deserializeAs('nom_rue')
  nomRue: string;

  @deserializeAs('complement_adresse')
  complementAdresse: string;

  @deserializeAs('code_postal')
  codePostal: string;

  @deserializeAs('commune')
  commune: string;

  toString(): string {
    return this.numeroRue + ' ' +  this.nomRue + ', ' + this.codePostal + ' ' + this.commune;
  }
}
